import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  DeleteProposalClientModel,
  SearchProposalClientModel,
} from '../../../models/proposal-client.model'
import { SearchScheduleFleetModel } from '../../../models/schedule-fleet.model'

@Injectable({
  providedIn: 'root',
})
export class ScheduleFleetService {
  private baseUrl = environment.baseUrl
  private resource = 'AgendaFrota'

  constructor(private httpClient: HttpClient) { }

  public createAgendaFrota(
    model: any,
    // model: CreateProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editAgendaFrota(
    model: any,
    // model: EditProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteAgendaFrota(
    model: DeleteProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }



  public listPagedAgendaFrota(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchAgendaFrota(
    model: SearchProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public listAgendaFrota(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getAgendaFrotabyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  // A listagem da Torre de Monitoramento saiu daqui e foi para
  // MonitoringService.searchPaginated (Monitoramento/search-paginated). A rota
  // antiga (search-paginated/monitoramento) continua no ar, mas nada mais a chama.

  public searchPagedAgendaFrota(
    page: number,
    rows = 15,
    model: SearchScheduleFleetModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/item-contrato/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  // Excel da listagem: mesmo corpo do search-paginated (filtros + ordenarPor/direcao),
  // sem paginação — a planilha é o recorte inteiro. Devolve o .xlsx direto. Acima de
  // 5000 serviços o back responde 400 pedindo pra estreitar o filtro.
  public exportarExcelAgendaFrota(
    model: SearchScheduleFleetModel,
  ): Observable<HttpResponse<Blob>> {
    return this.httpClient.post(
      `${this.baseUrl}${this.resource}/item-contrato/exportar-excel`,
      model,
      { observe: 'response', responseType: 'blob' },
    )
  }

  // Cronograma do motorista: o dia dele, na ordem do relógio. A data aceita
  // dd/MM/yyyy e yyyy-MM-dd. Uma consulta alimenta os três formatos (json/excel/pdf).
  public getCronogramaMotorista(
    motoristaId: number,
    data: string,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/cronograma-motorista`,
      { params: this.cronogramaParams(motoristaId, data) },
    )
  }

  public exportarCronogramaMotoristaExcel(
    motoristaId: number,
    data: string,
  ): Observable<HttpResponse<Blob>> {
    return this.httpClient.get(
      `${this.baseUrl}${this.resource}/cronograma-motorista/excel`,
      {
        params: this.cronogramaParams(motoristaId, data),
        observe: 'response',
        responseType: 'blob',
      },
    )
  }

  // Cada PDF sobe um Chromium no servidor e as gerações entram numa fila de uma por
  // vez — um clique, um PDF. Nunca chamar em loop nem em onChange de campo.
  public exportarCronogramaMotoristaPdf(
    motoristaId: number,
    data: string,
  ): Observable<HttpResponse<Blob>> {
    return this.httpClient.get(
      `${this.baseUrl}${this.resource}/cronograma-motorista/pdf`,
      {
        params: this.cronogramaParams(motoristaId, data),
        observe: 'response',
        responseType: 'blob',
      },
    )
  }

  private cronogramaParams(motoristaId: number, data: string): HttpParams {
    return new HttpParams()
      .set('motoristaId', motoristaId)
      .set('data', data)
  }

}
